class PageMessageBrokerSubscription {
  constructor(pageMessageBroker, messageType, callback) {
    this.pageMessageBroker = pageMessageBroker;
    this.messageType = messageType;
    this.callback = callback;
  }

  unsubscribe() {
    pageMessageBroker.unsubscribe(this.messageType, this.callback);
  }
}

class PageMessageBroker {
  constructor() {
    this.eventTarget = new EventTarget();
  }

  subscribe(messageType, callback) {
    this.eventTarget.addEventListener(messageType, callback);
    return new PageMessageBrokerSubscription(this, messageType, callback);
  }

  unsubscribe(messageType, callback) {
    this.eventTarget.removeEventListener(messageType, callback);
  }

  dispatch(messageType, detail) {
    console.log(`Dispatching message: ${messageType}`, detail);
    const event = new CustomEvent(messageType, { detail });
    this.eventTarget.dispatchEvent(event);
  }
}

const pageMessageBroker = new PageMessageBroker();

export default pageMessageBroker;
